import { useEffect } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";

/** Global clustered marker map. Markers: [{lat, lon, ...}].
 *  colorFor(marker) → hex colour; popupHtml(marker) → HTML string. */
function ClusterLayer({ markers, colorFor, popupHtml }) {
  const map = useMap();
  useEffect(() => {
    const group = L.markerClusterGroup({
      maxClusterRadius: 46,
      chunkedLoading: true,
      spiderfyOnMaxZoom: true,
    });
    markers.forEach((m) => {
      if (m.lat == null || m.lon == null) return;
      const color = colorFor ? colorFor(m) : "#166534";
      const cm = L.circleMarker([m.lat, m.lon], {
        radius: m.severity ? 4 + (m.severity || 1) * 1.4 : 7,
        fillColor: color, color: "#ffffff", weight: 1.5,
        opacity: 0.9, fillOpacity: 0.75,
      });
      if (popupHtml) cm.bindPopup(popupHtml(m), { maxWidth: 260 });
      group.addLayer(cm);
    });
    map.addLayer(group);
    if (markers.length > 3) {
      try { map.fitBounds(group.getBounds().pad(0.12)); } catch {}
    }
    return () => { map.removeLayer(group); };
  }, [markers, map, colorFor, popupHtml]);
  return null;
}

export default function ClusteredMap({
  markers, colorFor, popupHtml, center = [22, 10], zoom = 2,
  height = 440, testid = "clustered-map",
}) {
  return (
    <div data-testid={testid} className="rounded-3xl overflow-hidden border border-black/10 shadow-sm" style={{ height }}>
      <MapContainer center={center} zoom={zoom} minZoom={2} style={{ height: "100%", width: "100%" }} worldCopyJump>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ClusterLayer markers={markers} colorFor={colorFor} popupHtml={popupHtml} />
      </MapContainer>
    </div>
  );
}
